import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FaUserGraduate, FaUniversity } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import fb from "../../images/facebk.png";
import goog from "../../images/Google.png";
import stdimg from "../../images/std-login.png";
import instimg from "../../images/inst-log.png";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { baseUrl, baseLocal } from "../../context/BaseUrl";

const Loginstd = () => {
  const val = localStorage.getItem("user");
  const user = JSON.parse(val);
  if (user) {
    console.log(user.user._id);
    var id = user.user._id;
  }

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const [InlgShow, setInLgShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleInShow = () => setInLgShow(true);

  // for institute

  // Login Material
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [PhoneReg, setPhoneReg] = useState("");
  const [NameReg, setNameReg] = useState("");
  const [EmailReg, setEmailReg] = useState("");
  const [PasswordReg, setPasswordReg] = useState("");

  const handleLogin = async () => {
    try {
      console.log(Email, Password);
      const id = toast.loading("Try to login...");
      const response = await fetch(`${baseUrl}/user/login`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: Email,
          password: Password,
        }),
      });

      const result = await response.json();

      console.log("response______", result);
      const token = result.token;
      if (!result.token) {
        // alert("Enter Correct Details!");
        toast.update(id, {
          render: "login attempt failed!!",
          type: "error",
          isLoading: false,
        });
      } else {
        //   console.log("else_condition______");
        toast.update(id, {
          render: "Successfuly logged in.",
          type: "success",
          isLoading: false,
          closeButton: true,
        });
        localStorage.setItem("user", JSON.stringify(result));

        setTimeout(() => {
          navigate("/");
        }, 1500);
      }

      setTimeout(() => {
        toast.update(id, {
          render: "login attempt failed!!",
          type: "error",
          isLoading: false,
          closeButton: true,
        });
      }, 1500);

      // console.log(result, token);
    } catch (error) {
      toast.update(id, {
        render: "login attempt failed!!",
        type: "error",
        isLoading: false,
        closeButton: true,
      });
      console.log("login error______", error);
    }
  };

  const toggleAuth = () => {
    setLgShow(!lgShow);
    setShow(!show);
  };

  const handleSignup = async (role) => {
    try {
      // const id = toast.loading("Processing...");
      // if (EmailReg && PhoneReg && NameReg && PasswordReg.length > 8) {
      const response = await fetch(`${baseUrl}/signup`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: EmailReg,
          password: PasswordReg,
          role: role,
          mobile: PhoneReg,
          name: NameReg,
        }),
      });

      const result = await response.json();

      if (result.code == 500) {
        toast.error(result.msg);

        return;
      }

      toast.success("You're registered successfuly");

      if (role == "institute") {
        setInLgShow(false);
        return;
      }

      localStorage.setItem("user", JSON.stringify(result));

      setTimeout(() => {
        navigate(`/profile/${result.user._id}`);
      }, 1500);

      // }
    } catch (error) {
      toast.error("Internal Server Error !!", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="drop stdpopup">
        <div className="login">
          <button className="login" onClick={handleShow}>
            Login
          </button>

          <div className="hoverLoginOptions">
            <button className="btn" onClick={handleShow}>
              <FaUserGraduate /> <span>Login as Student</span>
            </button>
            <a href="https://obepedia-institute.netlify.app" className="btn">
              <FaUniversity /> <span>Login as Institute</span>
            </a>
          </div>
        </div>
        <div className="register nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block">
          <button className="started"> Get Started</button>
          <div className="hoverLoginOptions">
            <button className="btn" onClick={() => setLgShow(true)}>
              <FaUserGraduate /> <span>Register as Student</span>
            </button>
            <button className="btn" onClick={handleInShow}>
              <FaUniversity /> <span>Register as Institute</span>
            </button>
          </div>
        </div>
      </div>
      {/* <Dropdown className="nav-link-lg me-5 text-decoration-none d-none d-lg-inline-block">
                    <Dropdown.Toggle id="dropdown-basic">
                        Login
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ padding: '0px', borderRadius: '0px' }}>
                        <Dropdown.Item onClick={handleShow} className='dd-a' > Login as Student  </Dropdown.Item>
                       
                        <Dropdown.Item onClick={() => setLgShow(true)} className='dd-a' >Register as Student </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> */}

      {/* login as student */}
      <Modal show={show} onHide={handleClose} className="login-popup m-top-50">
        <Modal.Body className="login-form ">
          <div className="row">
            <div className="col-md-6 pe-0">
              <div className="form-img">
                <img src={stdimg} alt="login" className="loginimg" />
              </div>
            </div>
            <div className="col-md-6 ps-0">
              <Form>
                <Modal.Header closeButton>
                  <h4>Login as Student</h4>
                </Modal.Header>

                <Form.Group className="mb-4">
                  <Form.Control
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={Email}
                    id="number"
                    placeholder=" Mobile Number Or Email ID"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={Password}
                    id="Password"
                    placeholder="Password"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <small>Forgot Password</small>
                </Form.Group>
                <button onClick={handleLogin} type="button" className="signbtn">
                  Sign In{" "}
                </button>
                <Form.Group className="mb-4">
                  <a onClick={toggleAuth} className="acct">
                    Register account 
                  </a>
                </Form.Group>
                {/* <p className="with">Or Sign In with</p>
                <div className="social">
                  <img src={goog} alt="google" />
                  <img src={fb} alt="facebook" />
                </div> */}
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* register as student */}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        className="login-popup"
      >
        <Modal.Body className="login-form">
          <div className="row">
            <div className="col-md-6 pe-0">
              <div className="form-img">
                <img src={instimg} alt="login" />
              </div>
            </div>
            <div className="col-md-6 ps-0">
              <Form>
                <Modal.Header closeButton>
                  <h4>Register as Student</h4>
                </Modal.Header>

                <Form.Group className="mb-4">
                  <Form.Control
                    id="name"
                    onChange={(e) => setNameReg(e.target.value)}
                    value={NameReg}
                    placeholder="Full Name *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="number"
                    onChange={(e) => setPhoneReg(e.target.value)}
                    value={PhoneReg}
                    placeholder="Mobile Number *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="email"
                    onChange={(e) => setEmailReg(e.target.value)}
                    value={EmailReg}
                    placeholder="Email ID *"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    id="Password"
                    onChange={(e) => setPasswordReg(e.target.value)}
                    value={PasswordReg}
                    placeholder="Password *"
                  />
                </Form.Group>
                <Form.Group className="d-flex justify-content-between align-items-center mb-1">
                  <small className="text-black">
                    {" "}
                    <HiOutlineLocationMarker className="me-2" /> Delhi
                  </small>
                  <small>
                    <Link to="#" className="acct">
                      Change{" "}
                    </Link>
                  </small>
                </Form.Group>
                <button
                  type="button"
                  onClick={() => handleSignup("user")}
                  className="signbtn"
                >
                  {" "}
                  Register{" "}
                </button>
                <Form.Group className="mb-4">
                  <a onClick={toggleAuth} className="acct">
                    Login{" "}
                  </a>
                </Form.Group>
                {/* <p className="with"> Or Register In with </p>
                <div className="social">
                  <img src={goog} alt="google" />
                  <img src={fb} alt="facebook" />
                </div> */}
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* register as institute */}
      <Modal
        size="lg"
        show={InlgShow}
        onHide={() => setInLgShow(false)}
        className="login-popup"
      >
        <Modal.Body className="login-form">
          <div className="row">
            <div className="col-md-6 pe-0">
              <div className="form-img">
                <img src={instimg} alt="login" />
              </div>
            </div>
            <div className="col-md-6 ps-0">
              <Form>
                <Modal.Header closeButton>
                  <h4>Register as Institute</h4>
                </Modal.Header>

                <Form.Group className="mb-4">
                  <Form.Control
                    id="name"
                    onChange={(e) => setNameReg(e.target.value)}
                    value={NameReg}
                    placeholder="Full Name *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="number"
                    onChange={(e) => setPhoneReg(e.target.value)}
                    value={PhoneReg}
                    placeholder="Mobile Number *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="email"
                    onChange={(e) => setEmailReg(e.target.value)}
                    value={EmailReg}
                    placeholder="Email ID *"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    id="Password"
                    onChange={(e) => setPasswordReg(e.target.value)}
                    value={PasswordReg}
                    placeholder="Password *"
                  />
                </Form.Group>
                <button
                  type="button"
                  onClick={() => handleSignup("institute")}
                  className="signbtn"
                >
                  {" "}
                  Register{" "}
                </button>
                <Form.Group className="mb-4">
                  <a
                    href="https://obepedia-institute.netlify.app"
                    className="acct"
                  >
                    Login As Institute
                  </a>
                </Form.Group>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Loginstd;
